export default "__VITE_ASSET__cced15b5__"